/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RegistrationInfoDTO = {
    businessName?: string;
    registrationId?: string;
    registrationType?: RegistrationInfoDTO.registrationType;
    reviewComment?: string;
    /**
     * How compliance ruled on this item on its own: PENDING, VERIFIED, APPROVED or REJECTED. Null until compliance has ruled.
     */
    reviewStatus?: string;
    tradingName?: string;
};

export namespace RegistrationInfoDTO {

    export enum registrationType {
        INDIVIDUAL = 'INDIVIDUAL',
        SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
        LIMITED_LIABILITY = 'LIMITED_LIABILITY',
        NGO_NPO = 'NGO_NPO',
        GOVERNMENT = 'GOVERNMENT',
        PARTNERSHIP_INCORPORATED_TRUSTEES = 'PARTNERSHIP_INCORPORATED_TRUSTEES',
        CLUBS_SOCIETIES_ASSOCIATIONS = 'CLUBS_SOCIETIES_ASSOCIATIONS',
        COOPERATIVE_SOCIETIES = 'COOPERATIVE_SOCIETIES',
    }


}
